import { createSlice } from '@reduxjs/toolkit';
function uuidv4() {
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}
const initialState = {
  selectedColorId:[],
  outterlineColorGroup:[],
  outterline: true,
  simplify : 5,
  workId : "",
  resize: [0,0],
  resizeRatio : 0,
  svg : ''
};
let NextOutterlineColorGroupId = 0;

export const formDataSlice = createSlice({
  name: 'formData',
  initialState,
  reducers: {
    setWorkId(state, action) {
      state.workId = action.payload;
    },
    setResize(state, action) {
      state.resize = action.payload;
      state.resizeRatio = action.payload[0] / action.payload[1];
    },
    setOutterline(state, action) {
      state.outterline = action.payload;
    },
    setSvg(state, action) {
      state.svg = action.payload;
    },
    setSimplify(state, action) {
      state.simplify = action.payload;
    },
    setResizeAsRatio: {
      reducer(state, action) {
        const { index, value } = action.payload;
        if(index == 0){
          state.resize[index] = value;
          state.resize[1] = parseInt(value / state.resizeRatio);
        }else{
          state.resize[0] = parseInt(value * state.resizeRatio);
          state.resize[index] = value;
        }
      },
      prepare(data) {
        return { payload: { index : data.index, value: data.value } }
      }
    },
    setcolorSet: {
      reducer(state, action) {
        const { colorIdArr, id } = action.payload;
        if(typeof state.outterlineColorGroup[id] == 'undefined'){
          state.outterlineColorGroup.push([colorIdArr])
        }else{
          state.outterlineColorGroup[id].push(colorIdArr)
        }
      },
      prepare(data) {

        console.log(data);
        if(data.outterlineColorGroupId > NextOutterlineColorGroupId){
          return { payload: { colorIdArr : data.colorIdArr, id: data.outterlineColorGroupId } }
        }else{
          return { payload: { colorIdArr : data.colorIdArr, id: NextOutterlineColorGroupId++ } }
        }
      }
    },

    toggleColorToFormData(state, action) {

      const data = action.payload;
      const colorId = data.colorId;
      const colorArr = state.selectedColorId;
      
      const colorFilteredArr = colorArr.includes(colorId)
            ? colorArr.filter(i => i !== colorId) // remove item
            : [ ...colorArr, colorId ]; // add item

      state.selectedColorId = colorFilteredArr;

      if(data.groupIdx !== null){
        
        for(let i=0; i <= data.groupIdx; i++){
          if(state.outterlineColorGroup.length <= i){
            state.outterlineColorGroup.push( [] )
          }
        }
        const groupArr = state.outterlineColorGroup[data.groupIdx];
        let groupFilteredArr;
        let exist = false;
        //outterline true라면 groupIdx의 배열에 remove item 하고 해당 colorId가 없으면 groupIdx에 추가
        if(state.outterline){
          if(groupArr.includes(colorId)){
            groupFilteredArr = groupArr.filter(i => i !== colorId) // remove item
          }else{
            state.outterlineColorGroup.forEach(function(group){
              if (group.includes(colorId)){
                exist = true;
                return false;
              }
            })
            if( ! exist){
              groupFilteredArr = [ ...groupArr, colorId ] // add itme
            }else{
              throw new Error('colorId exists in other array')
              //원래 배열 할당
              groupFilteredArr = state.outterlineColorGroup[data.groupIdx];
            }
          }

          state.outterlineColorGroup[data.groupIdx] = groupFilteredArr;
        //outterline false라면 groupIdx와 상관없이 remove item 하고 해당 colorId가 없으면 groupIdx에 추가
        }else{

          state.outterlineColorGroup.forEach(function(group, gIdx){
            if (group.includes(colorId)){
              groupFilteredArr = group.filter(i => i !== colorId) // remove item
              state.outterlineColorGroup[gIdx] = groupFilteredArr;
              exist = true;
              return false;
            }
          })
          if( ! exist){
            groupFilteredArr = [ ...groupArr, colorId ] // add itme
            state.outterlineColorGroup[data.groupIdx] = groupFilteredArr;
          }
        }
      }
    },
    clearSelectedColor(state) {
      state.selectedColorId = [];
    },
    clearColorGroup(state) {
      state.outterlineColorGroup = [];
    },
    clearAllForm(state){
      state.selectedColorId = [];
      state.outterlineColorGroup = [];
      state.outterline = true;
      state.simplify = 5;
      state.svg = "";
    },
    changeWorkId(state){
      state.workId = uuidv4();
    }
  }
});

export const { 
  increment, 
  testDecrement, 
  setcolorSet, 
  toggleColorToFormData, 
  clearSelectedColor, 
  clearColorGroup, 
  setWorkId, 
  setResize, 
  setResizeAsRatio, 
  setOutterline, 
  setSvg, 
  setSimplify,
  clearAllForm,
  changeWorkId
} = formDataSlice.actions;
export const getWorkId = (state) => state.formData.workId;
export const getResize = (state) => state.formData.resize;
export const getSimplify = (state) => state.formData.simplify;
export const getOutterline = (state) => state.formData.outterline;
export const getOutterlineColorGroup = (state) => state.formData.outterlineColorGroup;
export const getSelectedColorId = (state) => state.formData.selectedColorId;
export const getSvg = (state) => state.formData.svg;

export default formDataSlice.reducer;
